const routes = [
    { path: "/", name: "home", component: () => import("@/views/dashboard/View"), meta: { login_required: true } },
    { path: "/settings", name: "settings", component: () => import("@/views/settings/Edit"), meta: { admin_route: true, unlockable: true } },
    { path: "/profile", name: "profile", component: () => import("@/views/user/Edit"), meta: { login_required: true, unlockable: true } },
    { path: "/users", name: "user.list", component: () => import("@/views/user/List"), meta: { admin_route: true, unlockable: true, scroll_position: true } },
    { path: "/user/badges", name: "user.badges", component: () => import("@/views/user/Badges"), meta: { admin_route: true } },
    { path: "/user/:id?", name: "user.edit", component: () => import("@/views/user/Edit"), meta: { admin_route: true } },
    { path: "/unsubscribe/:id", name: "user.newsletter-unsubscribe", component: () => import("@/views/user/Unsubscribe"), meta: { login_required: false } }
]

export default routes
